(() => {
  const OPEN_SELECTOR = '[data-eu-guarantee-open]';
  const CLOSE_SELECTOR = '[data-eu-guarantee-close]';
  const DIALOG_SELECTOR = '[data-eu-guarantee-dialog]';
  const triggers = new WeakMap();

  function syncScrollLock() {
    document.body.classList.toggle(
      'eu-guarantee-modal-open',
      Boolean(document.querySelector(`${DIALOG_SELECTOR}[open]`)),
    );
  }

  function openDialog(trigger) {
    const dialogId = trigger.getAttribute('aria-controls');
    let dialog = dialogId ? document.getElementById(dialogId) : null;
    if (trigger.hasAttribute('data-eu-guarantee-shared')) {
      dialog = dialog || document.querySelector(`main ${DIALOG_SELECTOR}[aria-label="Gesetzliche Gewährleistung"]`) ||
        document.querySelector(`${DIALOG_SELECTOR}[aria-label="Gesetzliche Gewährleistung"]`);
      if (!dialog) {
        const source = document.querySelector('[data-eu-guarantee-shared-template]')?.content.querySelector(DIALOG_SELECTOR);
        if (source) {
          dialog = source.cloneNode(true);
          document.body.append(dialog);
        }
      }
      if (dialog) trigger.setAttribute('aria-controls', dialog.id);
    }
    if (!(dialog instanceof HTMLDialogElement) || dialog.open) return;

    document.querySelectorAll(`${DIALOG_SELECTOR}[open]`).forEach((openDialogNode) => openDialogNode.close());
    triggers.set(dialog, trigger);

    // Product information can live inside transformed/sticky containers. Moving the
    // dialog to the document root keeps its fixed positioning relative to the viewport.
    if (dialog.parentElement !== document.body) document.body.append(dialog);

    dialog.showModal();
    syncScrollLock();
    requestAnimationFrame(() => dialog.querySelector(CLOSE_SELECTOR)?.focus());
  }

  function closeDialog(dialog) {
    if (dialog instanceof HTMLDialogElement && dialog.open) dialog.close();
  }

  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest?.(OPEN_SELECTOR);
    if (openTrigger) {
      event.preventDefault();
      openDialog(openTrigger);
      return;
    }

    const closeTrigger = event.target.closest?.(CLOSE_SELECTOR);
    if (closeTrigger) {
      event.preventDefault();
      closeDialog(closeTrigger.closest(DIALOG_SELECTOR));
      return;
    }

    if (event.target.matches?.(DIALOG_SELECTOR)) closeDialog(event.target);
  });

  document.addEventListener(
    'close',
    (event) => {
      if (!event.target.matches?.(DIALOG_SELECTOR)) return;
      syncScrollLock();
      const trigger = triggers.get(event.target);
      triggers.delete(event.target);
      trigger?.focus();
    },
    true,
  );
})();
